import { getCookie, removeCookie, setCookie } from "../Cookie";

const STORAGE_KEYS = {
  token: "__Token__",
  userName: "__UserName__",
  pass: "__Pass__",
  profile: "__Profile__",
  tokenEncrypt: "__TokenEnCrypt__",
  tokenAsset: "__TokenAsset__",
  tmpToken: "__TmpToken__",
  userPass: "__UserPass__",
  returnTo: "__ReturnTo__",
};

const readJsonCookie = (key, defaultValue = null) => {
  try {
    const raw = getCookie(key);
    return raw ? JSON.parse(raw) : defaultValue;
  } catch {
    return defaultValue;
  }
};

const writeJsonCookie = (key, value) => {
  setCookie(key, JSON.stringify(value));
};

export const handleSetToken = (token) => {
  writeJsonCookie(STORAGE_KEYS.token, token);
};
export const handleGetToken = () => {
  return readJsonCookie(STORAGE_KEYS.token);
};
export const handleSetUserName = (userName) => {
  writeJsonCookie(STORAGE_KEYS.userName, userName);
};

export const handleGetUserName = () => {
  return readJsonCookie(STORAGE_KEYS.userName);
};
export const handleSetPass = (pass) => {
  writeJsonCookie(STORAGE_KEYS.pass, pass);
};

export const handleGetPass = () => {
  return readJsonCookie(STORAGE_KEYS.pass);
};

export const handleSetTokenEnCrypt = (token) => {
  writeJsonCookie(STORAGE_KEYS.tokenEncrypt, token);
};

export const handleSetTokenAsset = (token) => {
  writeJsonCookie(STORAGE_KEYS.tokenAsset, token);
};

export const handleGetTokenEnCrypt = () => {
  return readJsonCookie(STORAGE_KEYS.tokenEncrypt);
};

export const handleGetTokenAsset = () => {
  return readJsonCookie(STORAGE_KEYS.tokenAsset);
};

export const handleSetProfile = (data) => {
  writeJsonCookie(STORAGE_KEYS.profile, data);
};

export const handleGetProfile = () => {
  return readJsonCookie(STORAGE_KEYS.profile);
};

export const handleSetTmpToken = (token) => {
  writeJsonCookie(STORAGE_KEYS.tmpToken, token);
};
export const handleGetTmpToken = () => {
  return readJsonCookie(STORAGE_KEYS.tmpToken);
};
export const handleRemoveTmpToken = () => {
  removeCookie(STORAGE_KEYS.tmpToken);
};
export const handleSetUserPass = (data) => {
  writeJsonCookie(STORAGE_KEYS.userPass, data);
};

export const handleGetUserPass = () => {
  return readJsonCookie(STORAGE_KEYS.userPass);
};

export const handleSetReturnTo = (returnTo) => {
  writeJsonCookie(STORAGE_KEYS.returnTo, returnTo);
};

export const handleGetReturnTo = () => {
  return readJsonCookie(STORAGE_KEYS.returnTo);
};

export const handleRemoveReturnTo = () => {
  removeCookie(STORAGE_KEYS.returnTo);
};

export const handleClearStoredAuth = () => {
  Object.values(STORAGE_KEYS).forEach((key) => removeCookie(key));
};

/** True when profile exists with a name and session password is present (same bar as relogin / histories). */
export const handleIsClientAuthenticated = () => {
  const profile = handleGetProfile();
  if (!profile || profile.Name === "" || !profile.Name) return false;

  const pass = handleGetUserPass();
  return Boolean(pass);
};

export const CLIENT_AUTH_CHANGED_EVENT = "vl:client-auth-changed";

export function notifyClientAuthChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(CLIENT_AUTH_CHANGED_EVENT));
}
